var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("fieldset", [
    _c("legend", [_vm._v(_vm._s(_vm.t("app-program-minimum-match")))]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ui-form-row" },
      [
        _c("app-select", {
          attrs: {
            label: _vm.t(
              "app-program-mentoring-relationship-commitment-months"
            ),
            options: _vm.monthOptions,
            required: true,
          },
          model: {
            value:
              _vm.program.attributes
                .programMentoringRelationshipCommitmentMonths,
            callback: function ($$v) {
              _vm.$set(
                _vm.program.attributes,
                "programMentoringRelationshipCommitmentMonths",
                $$v
              )
            },
            expression:
              "program.attributes.programMentoringRelationshipCommitmentMonths",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ui-form-row" },
      [
        _c("app-select", {
          attrs: {
            label: _vm.t(
              "app-program-mentoring-relationship-commitment-frequency"
            ),
            options: _vm.frequencyOptions,
            required: true,
          },
          model: {
            value:
              _vm.program.attributes
                .programMentoringRelationshipCommitmentFrequency,
            callback: function ($$v) {
              _vm.$set(
                _vm.program.attributes,
                "programMentoringRelationshipCommitmentFrequency",
                $$v
              )
            },
            expression:
              "program.attributes.programMentoringRelationshipCommitmentFrequency",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _vm.program.attributes.programMentoringRelationshipCommitmentFrequency ===
    "other"
      ? _c(
          "div",
          { staticClass: "ui-form-row" },
          [
            _c("app-input", {
              attrs: {
                type: "text",
                label: _vm.t(
                  "app-program-mentoring-relationship-commitment-frequency-other"
                ),
                required: true,
              },
              model: {
                value:
                  _vm.program.attributes
                    .programMentoringRelationshipCommitmentFrequencyOther,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.program.attributes,
                    "programMentoringRelationshipCommitmentFrequencyOther",
                    $$v
                  )
                },
                expression:
                  "program.attributes.programMentoringRelationshipCommitmentFrequencyOther",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ui-form-row" },
      [
        _c("app-select", {
          attrs: {
            label: _vm.t(
              "app-program-mentoring-relationship-commitment-hours-per-week"
            ),
            options: _vm.durationOptions,
            required: true,
          },
          model: {
            value:
              _vm.program.attributes
                .programMentoringRelationshipCommitmentHoursPerWeek,
            callback: function ($$v) {
              _vm.$set(
                _vm.program.attributes,
                "programMentoringRelationshipCommitmentHoursPerWeek",
                $$v
              )
            },
            expression:
              "program.attributes.programMentoringRelationshipCommitmentHoursPerWeek",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _vm.program.attributes
      .programMentoringRelationshipCommitmentHoursPerWeek === "other"
      ? _c(
          "div",
          { staticClass: "ui-form-row" },
          [
            _c("app-input", {
              attrs: {
                type: "text",
                label: _vm.t(
                  "app-program-mentoring-relationship-commitment-hours-per-week-other"
                ),
                required: true,
              },
              model: {
                value:
                  _vm.program.attributes
                    .programMentoringRelationshipCommitmentHoursPerWeekOther,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.program.attributes,
                    "programMentoringRelationshipCommitmentHoursPerWeekOther",
                    $$v
                  )
                },
                expression:
                  "program.attributes.programMentoringRelationshipCommitmentHoursPerWeekOther",
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }